import React from 'react';
import SuperAdminLayout from '../../layouts/SuperAdminLayout';
import { Typography, Box } from '@mui/material';

const SuperAdminDashboard = () => {
  return (
    <SuperAdminLayout>
      <Typography variant="h4" gutterBottom>
        Welcome Super Admin 👑
      </Typography>
      <Box sx={{ mt: 2 }}>
        <Typography>Here’s your dashboard content.</Typography>
      </Box>
    </SuperAdminLayout>
  );
};

export default SuperAdminDashboard;
